import Model from '../../ModelBinding/Model';
import dayjs from 'dayjs';
import MissionMediaFileCollection from './MissionMediaFileCollection';
import Member from '../Member/Member';
import MissionMediaMetaCollection from "../MissionMediaMeta/MissionMediaMetaCollection";
import MissionMediaFileUpload from '../MissionMediaFileUpload/MissionMediaFileUpload';

export default class MissionMediaFile extends Model {
  static rootUri = 'mission-media';

  public mime_type?: string;
  public original_filename?: string;
  public url?: string;
  public thumb?: string;
  public extension?: string;
  public md5?: string;
  public size?: string;
  public type?: string;
  public deliverable?: number;
  public version?: number;
  public upload_id?: string;
  public uploaded?: boolean;
  public created_by?: Member;
  public updated_by?: string;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public metas?: MissionMediaMetaCollection;
  public urls?: MissionMediaFileUpload;
  public displayable?: string;

  bind() {
    this.mime_type = this.getStringAttribute('mime_type');
    this.original_filename = this.getStringAttribute('original_filename');
    this.url = this.getStringAttribute('url');
    this.thumb = this.getStringAttribute('thumb');
    this.extension = this.getStringAttribute('extension');
    this.md5 = this.getStringAttribute('md5');
    this.size = this.getStringAttribute('size');
    this.type = this.getStringAttribute('type');
    this.deliverable = this.getIntAttribute('deliverable');
    this.version = this.getIntAttribute('version');
    this.upload_id = this.getStringAttribute('upload_id');
    this.uploaded = this.getBooleanAttribute('uploaded');
    this.created_by = this.getRelationAttribute('created_by', Member) as Member;
    this.updated_by = this.getStringAttribute('updated_by');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.metas = this.getRelationCollection('metas', MissionMediaMetaCollection) as MissionMediaMetaCollection;
    this.urls = this.getRelation('urls', MissionMediaFileUpload) as MissionMediaFileUpload;
    this.displayable = this.getStringAttribute('displayable');
  }

  static getCollection() {
    return MissionMediaFileCollection;
  }
}
